
import React from "react";
import PropTypes from "prop-types";

import "./helpsmall.css";

class Helpsmall extends React.Component {

  constructor(props) {
      super(props);
      this.state = {

      };
  }
  
  render() {
    
    return (
          <div data-layer="33724915-8da7-490a-8b9a-54098c3d6703" className="helpsmall">        <div data-layer="86e08551-d8d5-4aed-8566-c840c4b1921d" className="helpcard">            <div data-layer="8475cc7f-d1f9-4492-855d-cd42941100ef" className="rectangle9"></div>
            <div data-layer="9294d185-83cb-425a-b32f-fb58b674c600" className="pinkButton">                <div data-layer="c92db0d7-e6ce-40da-b294-7035e679df4b" className="background"></div>
                <div data-layer="96e02ede-d6ce-487e-ba3d-753a29465328" className="helpThem">Help Them</div>
</div>
            <div data-layer="34f7305f-312c-4878-9c23-eaaaeaeabc83" className="ridamSrivastava">Ridam Srivastava</div>
            <div data-layer="03b3a646-3a73-4972-97cf-1e86712f8555" className="x5KmAway">5 km away</div>
            <div data-layer="3b64ac45-05b5-4a25-8e81-4854d89db743" className="loremIpsumSiDolotEtAmet">lorem ipsum si dolot et amet<br /></div>
</div>
</div>

    );
  }
}

Helpsmall.propTypes = {

}

Helpsmall.defaultProps = {

}


export default Helpsmall;
          